import { ReactElement } from 'react';

import { visitPaths } from '~libs.desktop.shared.paths';

import { visitEncounterModeFilterStorage } from '../AppointmentsFilterPanel/fields/VisitEncounterModeField/VisitEncounterModeField.storage';
import { useAppointmentsFiltersContext } from '../AppointmentFilter.context';

import { ChipFilter } from './ChipFilter';
import { useVisitEncounterModeFilterLabel } from './VisitEncounterModeChipFilter.hooks';

export const VisitEncounterModeChipFilter = (): ReactElement | null => {
   const { getFilter } = useAppointmentsFiltersContext();

   const visitEncounterModes = getFilter('visitEncounterMode');
   const label = useVisitEncounterModeFilterLabel(visitEncounterModes);

   if (!visitEncounterModes.length) {
      return null;
   }
   return (
      <ChipFilter
         label={label}
         searchParamKey={visitPaths.VISIT_ENCOUNTER_MODE_SEARCH_PARAM}
         testId={'visitEncounterModeChipFilter'}
         onClick={visitEncounterModeFilterStorage.deleteFilter}
      />
   );
};
